import React from 'react';
import PropTypes from 'prop-types';
import { ParkingPass as ParkingPassModel } from 'models/parking-passes';
import BrandName from 'containers/common/brand-name';

function ResellerNotice({ parkingPass }) {
  if (!parkingPass.resellerPass) { return null; }

  return (
    <div className="row">
      <div className="col-xs-12 text-weight-medium">
        **<BrandName /> takes no responsibility for passes purchased on a third party website.
        All <BrandName /> terms and conditions are null and void on reseller passes.**
      </div>
    </div>
  );
}

ResellerNotice.propTypes = {
  parkingPass:  PropTypes.instanceOf(ParkingPassModel).isRequired,
};

export default ResellerNotice;
